module.exports = __webpack_public_path__ + "static/media/logo_footer_nhidonghcm.8269fc5e.gif";